import Tracker from '@openreplay/tracker';
import { EnvTypes } from './client/utils/base-url-util';

class AnalyticsTracker {
  constructor() {
    this.tracker = null;
  }

  static getOpenReplayProjectKey() {
    const stageEnv = process.env.REACT_APP_STAGE;
    switch (stageEnv) {
      case EnvTypes.SANDBOX:
        return 'Pwn7r96NKmeAG0K5D6hM';
      case EnvTypes.PROD:
        return 'fd3CFUUmhDNYDJauD6hH';
      default:
        return 'GwAFhBXBnBOYkYIGYGbL';
    }
  }

  static shouldRestrictAnalytics() {
    const stageEnv = process.env.REACT_APP_STAGE;
    return process.env.NODE_ENV === 'development' || stageEnv === EnvTypes.DEV
      || stageEnv === EnvTypes.PREPROD;
  }

  initAnalytics() {
    if (AnalyticsTracker.shouldRestrictAnalytics()) {
      return;
    }
    this.tracker = new Tracker({
      projectKey: AnalyticsTracker.getOpenReplayProjectKey(),
      ingestPoint: 'https://session.leegality.com/ingest',
      captureIFrames: false,
      obscureTextNumbers: true,
      inlineCss: 3,
      network: {
        failuresOnly: false,
        ignoreHeaders: ['x-auth-token'],
        capturePayload: true,
      },
    });
    this.tracker.start();
  }

  setMetadata(key, value) {
    if (AnalyticsTracker.shouldRestrictAnalytics()) {
      return;
    }
    this.tracker.setMetadata(key, value);
  }
}

const analyticsTrackerInstance = new AnalyticsTracker();

export default analyticsTrackerInstance;
